import React from "react";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { useActionHook } from "hooks";

interface Props {
  showDownload: boolean;
  downloadCashflowTable: () => void;
}

export const ManageBlock: React.FC<Props> = ({ downloadCashflowTable, showDownload }) => {
  const { action: downloadAction, loading } = useActionHook(downloadCashflowTable);

  return (
    <Stack sx={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
      <Stack sx={{ flexDirection: "row", alignItems: "center", gap: "20px" }}>
        <Typography sx={{ color: "#071F35", fontSize: "16px", lineHeight: "24px", fontWeight: 500 }}>
          Prediction Table
        </Typography>
      </Stack>

      <Stack sx={{ flexDirection: "row", gap: "10px" }}>
        {showDownload && (
          <IconButton
            onClick={downloadAction}
            disabled={loading}
            sx={{
              position: "relative",
              "& .MuiCircularProgress-root": {
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px"
              }
            }}
          >
            {loading ? <CircularProgress size={24} /> : <FileDownloadOutlinedIcon />}
          </IconButton>
        )}
        {/* <Button variant="outlined" startIcon={<RefreshIcon />}>
          Update current set
        </Button>
        <Button variant="contained" startIcon={<AddIcon />}>
          Save as new set
        </Button> */}
        {/* <Menu
          options={[
            {
              title: "Option 1",
              onClick: () => console.log("Option 1 clicked")
            },
            {
              title: "Option 2",
              onClick: () => console.log("Option 2 clicked")
            },
            {
              title: "Option 3",
              onClick: () => console.log("Option 3 clicked")
            }
          ]}
        /> */}
      </Stack>
    </Stack>
  );
};
